<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.6666 5L7.49998 14.1667L3.33331 10" stroke="#0097FF" stroke-width="1.66667" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>